import type { TagService } from '../tagService';
import type { TagRepository } from '../../../network/repositories/tagRepository';
import type { ITag } from '../../../entities';
import { TagType } from '../../../responses/responseTypes';

export default class TagServiceImpl implements TagService {
  tagRepository: TagRepository;

  constructor(tagRepository: TagRepository) {
    this.tagRepository = tagRepository;
  }

  getList(
    tagType: TagType,
    page?: number,
    pageSize?: number
  ): Promise<Array<ITag>> {
    const { tagRepository } = this;
    return tagRepository.getTagList(tagType, page, pageSize);
  }
}
